export const useLazyScroll = (desktop: number = 90, mobile: number = 72) => {
  const desktopOffset = desktop
  const mobileOffset = mobile
  const { isMobile } = useBSBreakpoints()

  const setLazyScrollTo = (hash: string) => {
    const el = document.querySelector(`${hash}`)
    const offset = isMobile.value ? mobileOffset : desktopOffset
    if (el) {
      const y = el?.getBoundingClientRect().top + window.pageYOffset - offset
      window.scrollTo({ top: y, behavior: 'smooth' })
    }
  }

  return {
    setLazyScrollTo,
  }
}
